export default __webpack_public_path__ + "static/media/ico-rds-score-high.406717a5.svg";